import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: 'Do you really come to my location?',
      answer: 'Yes! We bring all our professional equipment and supplies directly to your home, office, or any location of your choice. All we need is access to water and electricity.'
    },
    {
      question: 'What if it rains on the day of my appointment?',
      answer: 'We monitor weather conditions closely. For exterior services, we\'ll reschedule if heavy rain is expected. Interior detailing can proceed rain or shine. We\'ll contact you in advance if we need to adjust your appointment.'
    },
    {
      question: 'How long does a typical detail take?',
      answer: 'Exterior or interior detailing typically takes 1 to 1.5 hours each. A full detail package (both interior and exterior) usually takes 2 to 3 hours depending on the vehicle size and condition. We\'ll give you a more accurate estimate when you book.'
    },
    {
      question: 'Do I need to be present during the service?',
      answer: 'You don\'t need to stay for the entire service, but we do require someone to be present at the beginning for vehicle access and at the end for the final walkthrough and payment.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept cash, credit/debit cards, Venmo, Cash App, and Zelle for your convenience. Payment is due upon completion of service.'
    },
    {
      question: 'How far do you travel for mobile service?',
      answer: 'We service the local area and surrounding regions. Contact us with your location to confirm we can reach you. Some distant locations may have a small travel fee.'
    },
    {
      question: 'Can you remove all stains and odors?',
      answer: 'We use professional-grade products and equipment that can remove most stains and odors. However, some very old or set-in stains may not be 100% removable. We\'ll always do our absolute best and let you know what to expect.'
    },
    {
      question: 'Do you offer any guarantees?',
      answer: 'Your satisfaction is our top priority. We include a final walkthrough with every service where you can inspect our work. If you\'re not happy with any aspect, we\'ll address it before we leave.'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400">Questions</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Everything you need to know about our mobile detailing service
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-zinc-900/50 backdrop-blur-sm border border-yellow-500/20 rounded-xl px-6 hover:border-yellow-500 transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-white hover:text-yellow-400 py-6 text-lg font-semibold hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">Still have questions?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:4439421539"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-400 hover:from-yellow-600 hover:to-amber-500 text-black font-semibold rounded-lg transition-all duration-300 hover:scale-105"
            >
              Call (443) 942-1539
            </a>
            <a 
              href="mailto:jasonhines1008@gmail.com"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-yellow-500 text-yellow-400 hover:bg-yellow-500/10 font-semibold rounded-lg transition-all duration-300"
            >
              Send Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
